<template>
  <div
    class="mp-title small"
    :style="{ visibility: (!!(sellerId || initSellerId) && !!(sellerName || initSellerName)) ? 'visible' : 'hidden' }"
  >
    Shipped and sold by {{ sellerName || initSellerName }}
  </div>
</template>

<script setup>

import { watchEffect, ref } from 'vue';

import { useMarketPlace } from '@composables/useMarketPlace';

const {
  sellerName, sellerId, getInitSellerName, getInitSellerId,
} = useMarketPlace();

const initSellerName = ref(getInitSellerName());
const initSellerId = ref(getInitSellerId());

watchEffect(() => {
  if (sellerName?.value && sellerName?.value.length && sellerId?.value) {
    initSellerName.value = null;
    initSellerId.value = null;
    // TODO: stop the watcher once we capture 'current' seller name and id based on selected traits
  }
});

</script>

<style lang="scss" scoped>
@import "~settingSCSS";

.mp-title {
  color: $gray-1-color;
}
</style>
